import {
    ProfileEditState,
    AvailabilityState,
    AvailabilityType,
} from '../store/schema/ProfileEditState';

export default function initializeProfileEditState(): ProfileEditState {
    return {
        id: '',
        name: '',
        description: '',
        availability: {
            availabilityType: AvailabilityType.DefaultSetup,
            isDateRestricted: false,
            startDate: null,
            endDate: null,
            isTimeRestricted: false,
            customHours: [],
            isDirty: false,
        } as AvailabilityState,
        hasError: false,
        showErrorMessage: false,
        recipientErrorDetails: null,
    };
}
